module.exports = __webpack_public_path__ + "img/LM18.f088b3e1.png";